import React from 'react';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
// Constants
import {
  CompanyName,
  MainTitle,
} from '../../utils/Constants';
// Data
import {
  servicesPageAdditionalMeta,
  servicesPageStructuredData,
} from '../../utils/data/MetaData';
import ServicesPageMainContainer from '../../components/services/ServicesPageMainContainer';
import FooterComponent from '../../components/footer/FooterComponent';
import GeneralHeader from '../../components/general/GeneralHeader';
// Images
import SammiMainImage from '../../assets/images/noBackground/mistress-sammi-smith-trans-dominatrix-no-background-with-sub-on-cross.png';
import servicesHeaderMain from '../../assets/images/headers/services-header-barbie-style.png';

function ServicesPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Services'
        desc={`Get in touch with ${CompanyName} for expert web and circuit design services. We're here to help with your inquiries, quotes, or support needs.`}
        keywords={`contact, web design, circuit design, ${CompanyName}, customer support, inquiries, quotes, UK`}
        additionalMeta={servicesPageAdditionalMeta}
        structuredData={servicesPageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen bg-colour2 dark:bg-colour2 text-colour1 dark:text-colour1 w-full h-full font-poppins'>
        <div className='grid h-fit'>
          {/* Navigation */}
          <Navbar />
          <GeneralHeader
            headerMainImage={servicesHeaderMain}
            headerMobileImage={servicesHeaderMain}
            mainTitle={`${MainTitle}`}
            subtitle={`My BDSM Services`}
            mainImage={SammiMainImage}
          />
        </div>

        {/* Main page content */}
        <ServicesPageMainContainer />

        <FooterComponent />
      </div>
    </>
  );
}

export default ServicesPage;
